<template>
  <VueEasyLightbox
    :visible="isVisible"
    :imgs="imgs"
    :index="indexRef"
    @hide="onHide"
  />
</template>

<script setup lang="ts">
import VueEasyLightbox from "vue-easy-lightbox";

const lightboxStore = useLightboxStore();
const { isVisible, imgs, indexRef } = storeToRefs(lightboxStore);

const onHide = () => {
  isVisible.value = false;
};
</script>

<style scoped></style>
